module.exports = __webpack_public_path__ + "img/h.38d3533f.png";